import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ScoreModeProvider } from './contexts/ScoreModeContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Layout } from './components/Layout';
import { RepoDrillDown } from './pages/RepoDrillDown';
import { FeatureDrillDown } from './pages/FeatureDrillDown';
import { Calibration } from './pages/Calibration';
import { ScopeRoute } from './components/ScopeRoute';
import { RootScopeRoute } from './components/RootScopeRoute';
import { PreviewGallery } from './pages/PreviewGallery';

export function AppRoutes() {
  return (
    <Routes>
      {/* "Cox Automotive" root scope — all portfolios. The bare lens routes are the
          root's three views. */}
      <Route path="/" element={<RootScopeRoute lens="overview" />} />
      <Route path="/discovery" element={<RootScopeRoute lens="discovery" />} />
      <Route path="/delivery" element={<RootScopeRoute lens="delivery" />} />

      <Route path="/calibration" element={<Calibration />} />

      {/* FR-5: canonical typed leaf routes — owning team in the path. Ordered before
          the `/teams/:number/:lens?` scope route so the more specific leaf paths win. */}
      <Route path="/teams/:teamNumber/discovery/features/:formattedId" element={<FeatureDrillDown />} />
      <Route path="/teams/:teamNumber/delivery/repos/:org/:repo" element={<RepoDrillDown />} />

      {/* FR-1: typed per-tier scope routes. `:lens?` defaults to overview. */}
      <Route path="/portfolios/:number/:lens?" element={<ScopeRoute segment="portfolios" />} />
      <Route path="/delivery-streams/:number/:lens?" element={<ScopeRoute segment="delivery-streams" />} />
      <Route path="/release-trains/:number/:lens?" element={<ScopeRoute segment="release-trains" />} />
      <Route path="/teams/:number/:lens?" element={<ScopeRoute segment="teams" />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScoreModeProvider>
          <Routes>
            {/* Dev-only component gallery (FR-3/STEP-3) — rendered outside Layout so it
                isn't forced into dark mode; not linked in primary nav. */}
            <Route path="/_preview" element={<PreviewGallery />} />
            <Route
              path="*"
              element={
                <ThemeProvider>
                  <Layout>
                    <AppRoutes />
                  </Layout>
                </ThemeProvider>
              }
            />
          </Routes>
        </ScoreModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
